var Cards;
(function (Cards) {
    __once('paragraph--type--card', () => {
        console.log("js");
        const mainWrapperNode = document.querySelector('.paragraph--type--carousel');
        const titles = mainWrapperNode.querySelectorAll('.title');
        const descriptions = mainWrapperNode.querySelectorAll('.description-top');
        function setMinHeight(items) {
            let min_height = 0;
            items.forEach(item => {
                let current_height = item.clientHeight;
                min_height = current_height > min_height ? current_height : min_height;
            });
            items.forEach(item => {
                item.setAttribute('style', 'height: ' + min_height + 'px');
            });
        }
        function init() {
            if (mainWrapperNode) {
                setTimeout(() => {
                    setMinHeight(titles);
                    setMinHeight(descriptions);
                }, 100);
            }
        }
        init();
    });
})(Cards || (Cards = {}));
